import http from "../jslibs/axios/http";

// 学校列表
export const getSchoolList = (data) => http.get("/v1/cms/school", data);
// 新增
export const addSchool = (data) => http.post("/v1/cms/school", data);
// 编辑
export const editSchool = (data, uuid) => http.put(`/v1/cms/school/${uuid}`, data);
// 禁用
export const disableSchool = (uuid) => http.get(`/v1/cms/SchoolOption/${uuid}`);
// 详情
export const schoolDetail = (uuid) => http.get(`/v1/cms/school/${uuid}`);
// 导出
export const exportSchool = (data) => http.down(`/v1/cms/SchoolImport`, data);
